import React from "react";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { CheckNull, getStorageData } from "../../utils/Validate";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import AmountModeField from "../common/AmountModeField";
import QuoteFormSection from "./QuoteFormSection";
import {
  QuoteField,
  QuoteInputGroupField,
  QuoteSelectField,
  QuoteTextAreaField,
} from "./QuoteFormFields";

const halfColumn = "col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2";

const ProjectCommercialTermsSection = ({
  advPaymentLabel,
  CloseOthersOption,
  conversionDisabled,
  countryList,
  currency,
  currencyList,
  deliveryLeadTime,
  deliveryLeadTimeValues,
  deliveryTerms,
  deliveryTermsList,
  destinationCountry,
  distributor,
  distributorList,
  errors,
  HandleFormChange,
  HandleSelect,
  NoOptionsMessage,
  paymentTerms,
  paymentTermsList,
  project,
  projectData,
  quoteValidity,
  quoteValidityValues,
  selectProjRef,
  setDeliveryLeadTime,
  setDeliveryTerms,
  setDestinationCountry,
  setDistributor,
  setCurrency,
  setPaymentTerms,
  setProject,
  setQuoteValidity,
  setTransportMode,
  transportMode,
  transportModeList,
  values,
}) => (
  <QuoteFormSection title="Project & Commercial Terms">
    <div className="row compact-form-row">
      <QuoteSelectField id="quote-distributor" label="Distributor" required>
        <DropDownComponent
          placeHolder={PlaceHolder.SELECT_DISTRIBUTOR}
          pageName="jobinhand"
          dpDownName="distributor"
          stateData={distributorList}
          controlName="distributor"
          handleChange={(e) => HandleSelect(e, "distributor")}
          value={distributor}
          valueId={values?.distributorId?.toLowerCase()}
          setState={setDistributor}
          multiSelect={false}
          isDisabled={
            values?.id
              ? true
              : getStorageData()?.userType === 2 ? true : false
          }
        />
      </QuoteSelectField>

      <QuoteSelectField id="quote-project-name" label="Project Name" required error={errors.project}>
        <DropDownComponent
          placeHolder={values?.distributorId ? PlaceHolder?.SELECT_PROJECT : PlaceHolder?.SHOULD_CHOOSE_FIELD("project")}
          pageName="jobinhand"
          dpDownName="project"
          stateData={projectData}
          controlName="project"
          handleChange={(e) => HandleSelect(e, "project")}
          value={project}
          valueId={values?.projectId}
          setState={setProject}
          multiSelect={false}
          refComp={selectProjRef}
          components={values?.distributorId ? { NoOptionsMessage } : ""}
          isDisabled={
            values?.id && CheckNull(values?.enquiryId) != ""
              ? true
              : CheckNull(values?.enquiryId) != "" ? true : false
          }
        />
      </QuoteSelectField>

      <QuoteSelectField id="quote-validity" label="Quote Validity" required error={errors.quoteValidity}>
        <DropDownComponent
          isDisabled={false}
          placeHolder={PlaceHolder.SELECT_QUOTE_VALIDITY}
          pageName="jobinhand"
          dpDownName="quotevalidity"
          stateData={quoteValidityValues}
          controlName="quoteValidity"
          handleChange={(e) => HandleSelect(e, "quoteValidity")}
          value={quoteValidity}
          valueId={values?.quoteValidity?.toString()}
          setState={setQuoteValidity}
          multiSelect={false}
        />
      </QuoteSelectField>

      <QuoteSelectField id="quote-payment-terms" label="Payment Terms" required error={errors.paymentTerms}>
        <DropDownComponent
          isDisabled={false}
          placeHolder={PlaceHolder.SELECT_PAYMENT_TERMS}
          pageName="jobinhand"
          dpDownName="paymentterms"
          stateData={paymentTermsList}
          controlName="paymentterms"
          handleChange={(e) => HandleSelect(e, "paymentterms")}
          value={paymentTerms}
          valueId={values?.paymentTermId?.toLowerCase()}
          setState={setPaymentTerms}
          multiSelect={false}
        />
      </QuoteSelectField>

      <QuoteSelectField id="quote-currency" label="Currency" required className={halfColumn} error={errors.currency}>
        <DropDownComponent
          isDisabled={distributor?.defaultCompanyDistributor === true ? false : true}
          placeHolder={PlaceHolder.SELECT_CURRENCY}
          pageName="jobinhand"
          dpDownName="currencyCode"
          stateData={currencyList}
          controlName="currency"
          handleChange={(e) => HandleSelect(e, "currency")}
          value={currency}
          valueId={values?.currencyId}
          setState={setCurrency}
          multiSelect={false}
        />
      </QuoteSelectField>

      <QuoteInputGroupField
        id="quote-conversion-rate"
        label="Conversion rate"
        required
        className={halfColumn}
        error={errors.conversionRate}
      >
        <input
          id="quote-conversion-rate"
          type="text"
          className="form-control"
          placeholder="Enter currency exchange"
          name="conversionRate"
          onChange={HandleFormChange}
          value={values?.conversionRate || ""}
          disabled={conversionDisabled}
        />
        <span className="input-group-text" id="quote-conversion-addon">
          1 QAR
        </span>
      </QuoteInputGroupField>

      <QuoteField id="quote-advance-payment" label="Advance Payment" className={halfColumn} error={errors.advancePayment}>
        <AmountModeField
          id="quote-advance-payment"
          mode={advPaymentLabel ? "$" : "%"}
          name={advPaymentLabel ? "advancePayment" : "paymentPercentage"}
          onChange={HandleFormChange}
          onModeToggle={() => {
            HandleFormChange({ target: { name: "advance_mode", type: "checkbox", checked: !advPaymentLabel } });
          }}
          placeholder="Enter advance payment"
          type="text"
          value={
            advPaymentLabel
              ? values?.advancePayment > 0 ? values?.advancePayment : ""
              : values?.paymentPercentage > 0 ? values?.paymentPercentage : ""
          }
        />
      </QuoteField>

      <QuoteField
        id="quote-credit-days"
        label="Credit Days"
        required
        className={halfColumn}
        type="text"
        placeholder="Choose days"
        name="creditdays"
        value={values?.creditDays}
        disabled={true}
      />

      {deliveryLeadTime?.label != "Others" && (
        <QuoteSelectField id="quote-delivery-lead-time" label="Delivery Lead Time" required error={errors.deliveryLeadTime}>
          <DropDownComponent
            isDisabled={false}
            placeHolder={PlaceHolder.SELECT_DELIVERY_LEAD_TIME}
            pageName="jobinhand"
            dpDownName="status"
            stateData={deliveryLeadTimeValues}
            controlName="deliveryLeadTime"
            handleChange={(e) => HandleSelect(e, "deliveryLeadTime")}
            value={deliveryLeadTime}
            valueId={values?.deliveryLeadTimeId}
            setState={setDeliveryLeadTime}
            multiSelect={false}
          />
        </QuoteSelectField>
      )}

      {deliveryLeadTime?.label == "Others" && (
        <QuoteInputGroupField id="quote-delivery-lead-time-other" label="Delivery Lead Time" error={errors.deliveryLeadTime}>
          <input
            id="quote-delivery-lead-time-other"
            className="form-control"
            type="text"
            placeholder="Enter others"
            name="deliveryLeadTime"
            onChange={HandleFormChange}
            value={values?.deliveryLeadTime}
          />
          <span className="input-group-text" onClick={() => CloseOthersOption("deliveryLeadTime")}>
            <i className="fas fa-times"></i>
          </span>
        </QuoteInputGroupField>
      )}

      {deliveryTerms?.label != "Others" && (
        <QuoteSelectField id="quote-delivery-terms" label="Delivery Terms" required error={errors.deliveryTerms}>
          <DropDownComponent
            isDisabled={false}
            placeHolder={PlaceHolder.SELECT_DELIVERY_TERMS}
            pageName="jobinhand"
            dpDownName="deliveryterms"
            stateData={deliveryTermsList}
            controlName="deliveryterms"
            handleChange={(e) => HandleSelect(e, "deliveryterms")}
            value={deliveryTerms}
            valueId={values?.deliveryTermId}
            setState={setDeliveryTerms}
            multiSelect={false}
          />
        </QuoteSelectField>
      )}

      {deliveryTerms?.label == "Others" && (
        <QuoteInputGroupField id="quote-delivery-terms-other" label="Delivery Terms" error={errors.deliveryTerms}>
          <input
            id="quote-delivery-terms-other"
            className="form-control"
            type="text"
            placeholder="Enter others"
            name="deliveryTerms"
            onChange={HandleFormChange}
            value={values?.deliveryTerms}
          />
          <span className="input-group-text" onClick={() => CloseOthersOption("deliveryTerms")}>
            <i className="fas fa-times"></i>
          </span>
        </QuoteInputGroupField>
      )}

      {(values?.deliveryTermId != "" || deliveryTerms?.label == "Others") && (
        <QuoteSelectField
          id="quote-transport-mode"
          label="Mode of Transport"
          required={deliveryTerms?.countryRequired || values?.deliveryTermId}
          className={halfColumn}
          error={errors.modeOfTransport}
        >
          <DropDownComponent
            isDisabled={false}
            placeHolder={PlaceHolder.SELECT_TRANSPORT_MODE}
            pageName="jobinhand"
            dpDownName="transportmode"
            stateData={transportModeList}
            controlName="transportmode"
            handleChange={(e) => HandleSelect(e, "transportmode")}
            value={transportMode}
            valueId={values?.modeOfTransportId}
            setState={setTransportMode}
            multiSelect={false}
          />
        </QuoteSelectField>
      )}

      {(deliveryTerms?.countryRequired || deliveryTerms?.label == "Others") && (
        <QuoteSelectField
          id="quote-destination-country"
          label="Destination Country"
          className={halfColumn}
          error={errors.destinationCountry}
        >
          <DropDownComponent
            isDisabled={false}
            placeHolder={PlaceHolder.SELECT_COUNTRY}
            pageName="jobinhand"
            dpDownName="country"
            stateData={countryList}
            controlName="destinationCountry"
            handleChange={(e) => HandleSelect(e, "destinationCountry")}
            value={destinationCountry}
            valueId={values?.destinationCountryId}
            setState={setDestinationCountry}
            multiSelect={false}
          />
        </QuoteSelectField>
      )}

      {(deliveryTerms?.destinationRequired || deliveryTerms?.value == "Others") && (
        <QuoteField
          id="quote-destination"
          label="Destination"
          error={errors.destination}
          type="text"
          placeholder="Enter destination"
          name="destination"
          onChange={HandleFormChange}
          value={values?.destination}
        />
      )}

      <QuoteTextAreaField
        id="quote-additional-info"
        label="Additional info"
        className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
        error={errors.additionalInfo}
        inputClassName="additional-info-text-area"
        placeholder="Enter your notes here"
        rows="5"
        name="additionalInfo"
        onChange={HandleFormChange}
        value={values?.additionalInfo}
      />
    </div>
  </QuoteFormSection>
);

export default React.memo(ProjectCommercialTermsSection);
